import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export const EmptyState = ({
  title,
  description,
}: {
  title: ReactNode;
  description: ReactNode;
}) => {
  return (
    <Box
      p={2}
      textAlign="center"
      sx={{
        width: '100%',
        border: theme => `1px solid ${theme.palette.divider}`,
        borderRadius: borderRadius('m'),
        backgroundColor: theme => theme.palette.action.hover,
      }}
    >
      <Stack>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Stack>
    </Box>
  );
};
